import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import TabPanel from "../../DesignSystem/TabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import img from "../../assets/store.png";
import BusinessDetailsCard from "../../DesignSystem/BusinessDetailsCard";
import BusinessOfferCard from "../../DesignSystem/BusinessOfferCard";
import BusinessProducts from "../../DesignSystem/BusinessProducts";
import BusinessComments from "../../DesignSystem/BusinessComments";
import BusinessImage from "../../DesignSystem/BusinessImage";
import PercentIcon from "@mui/icons-material/Percent";
import { GetBusinessInfo, GetListOfferProducts } from "../Infrastructure/Business.presenter";
import { GetUserInfo } from "../../User/Infrastructure/User.presenter";
import BusinessLocation from "../../DesignSystem/BusinessLocation";
import BusinessCommissionsTable from "../../DesignSystem/BusinessCommissionsTable";
import ModalAlert from "../../DesignSystem/ModalAlert";
import { GetPhotoProfile } from "../../User/Infrastructure/User.presenter";

const headerContainer = {
  background: "white",
  borderRadius: "10px",
  width: "100%",
  height: "95px",
  maxWidth: "1164px",
  minHeight: "95px",
  padding: { xs: "60px 5px", sm: "40px 20px", md: "46px 40px 50px" },
  paddingTop: { lg: "10px" },
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
};

const headerInfo = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",
  marginBottom: "20px",
  gridColumn: "1/-1",
  justifySelf: "start",
};

const typeTabs = {
  fontWeight: 700,
  fontFamily: "Montserrat",
  color: "#000",
  textTransform: "none",
};

const businessImageStyles = {
  borderRadius: "50%",
  objectFit: "cover",
  width: 66,
  height: 66,
  marginRight: "20px",
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "1.20fr 2fr",
    width: "100%",
    maxWidth: "1164px",
    top: "16%",
    left: "13.5%",
    marginTop: "auto",
    gap: "20px 40px",
    [theme.breakpoints.down("lg")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
  },
  productsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  iconBag: { marginRight: "20px" },
  subtitle: {
    color: "#333333",
    fontWeight: 400,
    fontSize: "1.5rem",
    marginBottom: "10px",
  },
  listProducts: {
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px 60px",
    },
  },
  products: { height: "265px" },
  address: {
    height: "46px",
    width: "311px",
    marginTop: "10px",
  },
  offersContainer: {
    borderRadius: 10,
    padding: "18px 40px 18px",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    width: "100%",
    maxWidth: "710px",
    height: "auto",
    minHeight: "250px",
    background: "#FFFFFF",
    marginTop: 10,
    [theme.breakpoints.down("md")]: {
      maxWidth: "360px",
      display: "none"
    },
  },
  titleInfo: {
    lineHeight: "29.05px",
    fontWeight: 600,
    color: "#333333",
    fontSize: "1.5rem",
  },
  productsContainer:{
    width: "100%",
    height: "auto",
    [theme.breakpoints.down("md")]: {
      display: "none"
    },
  }
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BussinesInfo() {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [businessRender, setBusinessRender] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [offers, setOffers] = useState([]);
  const [business, setBusiness] = useState({
    id: "",
    name: "",
    schedule: "",
    description: "",
    addressCoords: "",
    addressShop: "",
    affiliatorId: "",
    createdAt: "",
    products: "",
    sellerId: "",
    urlDocuments: "",
    urlImage: "",
    urlPdf: "",
    price: 0
  });
  const [affiliatorInfo, setAffiliatorInfo] = useState({
    id: "",
    name: "",
    lastName: "",
  });
  const [isOpenAlert, setOpenAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getUrlPhoto = async (urlPhoto) =>{
    const res = await GetPhotoProfile(urlPhoto);
    setPhoto(res);
  }

  useEffect(() => {
    if (id) {
      fetchDataBusiness(id);
      getListOffers(id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  async function fetchDataBusiness(id) {
    try {
      const { valid, info } = await GetBusinessInfo(id);
      if (valid) {
        setBusiness({
          ...business,
          id: info.id,
          name: info.shop_name,
          schedule: info.schedule,
          description: info.description,
          addressCoords: info.address_coords,
          addressShop: info.address_shop,
          affiliatorId: info.affiliator_id,
          createdAt: info.createdAt,
          products: info.products,
          sellerId: info.seller_id,
          urlDocuments: info.url_documents,
          urlImage: info.url_image,
          urlPdf: info.url_pdf,
          price: parseInt(info.price)
        });
        //getFormatedSchedule();
        setBusinessRender(true);
        
        fetchAffiliatorData(info.affiliator_id);
        if (info.url_image !== null) {
          getUrlPhoto(info.url_image)
        }

      } else {
        setTitleAlert("Ha ocurrido un error al obtener la información");
        showAlertModal();
        history.push("/negocios");
      }
    } catch (error) {
      showAlertModal();
    }
  }

  async function fetchAffiliatorData(id) {
    try {
      const info = await GetUserInfo(id);
      setAffiliatorInfo({
        ...affiliatorInfo,
        id: info.id,
        name: info.name,
        lastName: info.last_name,
      });
    } catch (error) {
      setAffiliatorInfo(null);
      console.log("Afiliador no encontrado")
    }
  }

  async function getListOffers(id){
    try {
      const {items} = await GetListOfferProducts(id);
      setOffers(items);
    } catch (error) {
      console.log("ha ocurrido un error al obtener las ofertas")
    }
  }

  return (
    <Box
      sx={{
        paddingTop: { xs: "0px", md: "20px" },
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box sx={headerContainer}>
        <div className={classes.header}>
          <BusinessImage businessImage={photo} customStyles={businessImageStyles}/>
          {/* <img className={classes.businessImage} src={business.urlImage ? photo : img} alt="" /> */}
          <h3>{business.name}</h3>
        </div>
        <Tabs textColor="secondary" indicatorColor="secondary" value={value} onChange={handleChange}>
          <Tab sx={typeTabs} label="Información" {...a11yProps(0)} />
          <Tab sx={typeTabs} label="Público" {...a11yProps(1)} />
          <Tab sx={typeTabs} label="Comisiones" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <div>
        <TabPanel value={value} index={0}>
          <Box className={classes.root}>
            <BusinessDetailsCard
              id={id}
              name={business.name}
              description={business.description}
              adviserName={affiliatorInfo !== null && `${affiliatorInfo.name} ${affiliatorInfo.lastName}`}
              schedule={business.schedule}
              createdAt={business.createdAt}
              sellerName={business.sellerId !== null && `${business.sellerId.name} ${business.sellerId.last_name}`}
              image={business.urlImage ? photo : img}
              price={business.price}
            />
            <div>
              <BusinessLocation
                id={id}
                address={business.addressShop}
                addresCoords={business.businessCords}
              />
              { offers.length !== 0 &&
                <div className={classes.offersContainer}>
                  <Box sx={headerInfo}>
                    <PercentIcon
                      sx={{ color: "#EA5B13", width: "24px", height: "24px", display: {xs: "none", md: "flex"} }}
                    />
                    <h4 className={classes.titleInfo}>Ofertas</h4>
                  </Box>
                  {offers.map((offer) => (
                    <BusinessOfferCard key={offer.id} id={offer.id} offerPrice={offer.offerprice} realPrice={offer.price} name={offer.product_name} description={offer.description} image={offer.url_image} amount={offer.netcontent}/>  
                  ))}
                </div>
              }
              {businessRender && <div className={classes.productsContainer}><BusinessProducts business={business} /></div>}
            </div>
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box className={classes.root}>
            <BusinessDetailsCard
              id={id}
              name={business.name}
              description={business.description}
              adviserName={affiliatorInfo !== null && `${affiliatorInfo.name} ${affiliatorInfo.lastName}`}
              schedule={business.schedule}
              createdAt={business.createdAt}
              sellerName={business.sellerId !== null && `${business.sellerId.name} ${business.sellerId.last_name}`}
              price={business.price}
              image={business.urlImage ? photo : img}
            />
            <div>
              <BusinessComments businessId={id} />
            </div>
          </Box>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <BusinessCommissionsTable businessName={business.name} businessId={id} />
        </TabPanel>
      </div>
      {/*  </Box> */}
      <ModalAlert
        title={titleAlert}
        typeAlert={"error"}
        isOpen={isOpenAlert}
        handleAlert={handleClickOpen}
      />
    </Box>
  );
}
